import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Utensils, Mic2, Shield, LayoutGrid } from "lucide-react";
import { useLang, LANGS } from "../lib/i18n";

const LOGO = "/images/5ff2283bf031.png";

const roles = [
  { path: "/venue", key: "restaurant", icon: Utensils, testid: "role-venue" },
  { path: "/artist", key: "artist", icon: Mic2, testid: "role-artist" },
  { path: "/admin", key: "admin", icon: Shield, testid: "role-admin" },
];

function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center rounded-sm border border-white/15 overflow-hidden mr-1" data-testid="lang-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`px-2 py-1.5 text-xs font-semibold tracking-wide transition-colors ${
            lang === l.code ? "bg-gold text-black" : "text-neutral-400 hover:text-white"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLang();
  const onLanding = location.pathname === "/";

  return (
    <nav className="glass sticky top-0 z-50 border-b border-white/10" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <img src={LOGO} alt="Buskers on the Table" className="h-11 w-11 object-contain rounded-sm" />
          <span className="hidden sm:inline font-serif-lux text-lg text-white tracking-wide">
            Buskers<span className="gold"> on the Table</span>
          </span>
        </Link>

        <div className="flex items-center gap-1.5">
          <LanguageSwitcher />
          {!onLanding && (
            <Link
              to="/"
              data-testid="nav-home"
              className="hidden sm:flex items-center gap-1.5 px-3 py-2 text-sm text-neutral-400 hover:text-white transition-colors"
            >
              <LayoutGrid size={15} /> {t.nav.home}
            </Link>
          )}
          {roles.map((r) => {
            const active = location.pathname.startsWith(r.path);
            const Icon = r.icon;
            return (
              <button
                key={r.path}
                data-testid={r.testid}
                onClick={() => navigate(r.path)}
                className={`flex items-center gap-1.5 px-3 py-2 text-sm rounded-sm transition-colors border ${
                  active ? "bg-gold text-black border-gold" : "border-transparent text-neutral-300 hover:text-white hover:bg-white/5"
                }`}
              >
                <Icon size={15} />
                <span className="hidden sm:inline">{t.nav[r.key]}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
